import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, Briefcase, Activity, TrendingUp } from "lucide-react";
import { ContactsList } from "@/components/crm/ContactsList";
import { DealsPipeline } from "@/components/crm/DealsPipeline";
import { CRMAnalytics } from "@/components/crm/CRMAnalytics";
import { ActivitiesLog } from "@/components/crm/ActivitiesLog";

export default function CRM() {
  const [activeTab, setActiveTab] = useState("contacts");

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Customer Relationship Management</h1>
        <p className="text-muted-foreground">Manage your leads, contacts, and deals all in one place</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="contacts">
            <Users className="mr-2 h-4 w-4" />
            Contacts
          </TabsTrigger>
          <TabsTrigger value="deals">
            <Briefcase className="mr-2 h-4 w-4" />
            Deals
          </TabsTrigger>
          <TabsTrigger value="activities">
            <Activity className="mr-2 h-4 w-4" />
            Activities
          </TabsTrigger>
          <TabsTrigger value="analytics">
            <TrendingUp className="mr-2 h-4 w-4" />
            Analytics
          </TabsTrigger>
        </TabsList>

        <TabsContent value="contacts">
          <ContactsList />
        </TabsContent>

        <TabsContent value="deals">
          <DealsPipeline />
        </TabsContent>

        <TabsContent value="activities">
          <ActivitiesLog />
        </TabsContent>

        <TabsContent value="analytics">
          <CRMAnalytics />
        </TabsContent>
      </Tabs>
    </div>
  );
}